import {
    ArrayField,
    ArrayFieldProps,
    ArrayInput,
    ArrayInputProps,
    AutocompleteInput,
    Datagrid,
    NumberField,
    NumberInput,
    ReferenceArrayField,
    ReferenceArrayFieldProps,
    ReferenceField,
    ReferenceInput,
    required,
    SimpleFormIterator,
    TextField,
    TextFieldProps,
    useRecordContext,
  } from 'react-admin';
import { locale, numberFormatConfiguration } from '../../components/numberFormatConfiguration';
import { QuickbooksCalculatedPriceField } from '../../components/QuickbooksCalculatedPriceField';
  import { LinesDescriptionInput } from './LinesDescriptionInput';
  import { LinesPriceInput } from './LinesPriceInput';
  import { LineTaxInput } from './LinesTaxInput';
  import { LinesTypeField } from './LinesTypeField';


const ShowTotalPriceField = (props: Omit<TextFieldProps, 'children'>) => {
    const record = useRecordContext();

    const price = record.price;
    const quantity = record.quantity;
    const storedTotal = record.total;
    
    let total = 0;
    
    // Use the stored total from QuickBooks if available
    if (storedTotal !== undefined && storedTotal !== null) {
      total = storedTotal;
    } else if (price != null && quantity != null) {
      // Otherwise calculate it
      total = price * quantity;
    }

    const displayPrice = Intl.NumberFormat(
        locale,
        numberFormatConfiguration
      ).format(total);
      
    return <span>{displayPrice}</span>
  };

  const contractRowStyle = (record: any, index: number) => ({
    backgroundColor: record.quantity < 0 ? '#F9B7B5' : 'white',
  });
  
  export const LinesShow = (props: Omit<ArrayFieldProps, 'children'>) => {
    return (
      <ArrayField
        label="resources.contracts.lines.name"
        // sx={{
        //   '& .RaSimpleFormIterator-form': {
        //     flexDirection: 'row !important',
        //     gap: '15px',
        //     alignItems: 'center !important',
        //   },
        // }}
        {...props}
      >
          <Datagrid bulkActionButtons={false} rowStyle={contractRowStyle}>
            <ReferenceField source="item" reference="items" link={false}>
                <TextField source="FullyQualifiedName" />
            </ReferenceField>
            <TextField source="description" />
            <NumberField source="price" />
            <NumberField source="quantity" />
            <ShowTotalPriceField label="Total"/>
 
        {/* //   <LinesTypeField label="resources.items.fields.Type" />
        //   <LinesDescriptionInput
        //     source="description"
        //     label="resources.items.fields.Description"
        //   />
        //   <LinesPriceInput
        //     source="price"
        //     label="resources.items.fields.UnitPrice"
        //     sx={{
        //       width: 125,
        //     }}
        //   />
        //   <NumberInput
        //     source="quantity"
        //     defaultValue={1}
        //     min={1}
        //     max={100}
        //     sx={{
        //       width: 75,
        //     }}
        //     label="resources.contracts.fields.quantity"
        //   />
        //   <TotalPriceField source="total" />
        //   <LineTaxInput
        //     sx={{
        //       width: 125,
        //     }}
        //     source="tax"
        //     reference="taxes"
        //     label="resources.contracts.fields.tax"
        //   /> */}
          </Datagrid>
      </ArrayField>
    );
  };
  